export enum ModalEventTypeEnum {
  open = 'open',
  close = 'close'
}
